export default "https://cdn-static.gokick.com/assets/0488227f5b7e53bbf90738be35137ce008cd4a94/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";